<template>
  <div class="setting-layout layout-page">
    <div class="tabs clear">
      <Tabs v-model="pageIndex" line-width="56px" color="#353945" title-active-color="#353945" title-inactive-color="#9FA4AD" @change="chagneTab">
        <Tab :title="$t('qi-quan-ding-dan')">
          <div class="layout-main">
            <router-view v-if="pageIndex == 0"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('he-yue-ding-dan')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 1"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('xian-huo-ding-dan')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 2"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('jin-rong-ding-dan')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 3"></router-view>
          </div>
        </Tab>
        <Tab :title="$t('gen-dan-ding-dan')">
           <div class="layout-main">
            <router-view v-if="pageIndex == 4"></router-view>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';
export default {
  components: {
    Tabs,
    Tab
  },
  data() {
    return {
      pageIndex: 0
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let type = this.$route.query.type
      this.pageIndex = type == 2 ? 0 :
                       type == 3 ? 1 :
                       type == 1 ? 2 :
                       type == 6 ? 3 : 4
    },
    chagneTab() {
      let type = this.pageIndex == 0 ? 2 :
                 this.pageIndex == 1 ? 3 :
                 this.pageIndex == 2 ? 1 :
                 this.pageIndex == 3 ? 6 : 7
      this.$router.push({
        name: 'orderList',
        query: {
          type: type
        }
      })
    }
  }
}
</script>